<template>
  <div class="background">

    <el-row class="info">
      <el-col :span="11" class="left">
        <div> <img src="/static/imgs/footerPage/2.png" /></div>
        <span>联系电话：400-0220-165</span>
        <span>邮箱：wanting.ma@face2x.com</span>
        <span>地址：上海市嘉定区丰华公路688号1号楼C-2</span>
      </el-col>
      <el-col :span="10" class="right">
        <el-row :gutter="8">
          <el-col :span="12">
            <div>
              <img src="/static/imgs/footerPage/3.jpg" />
            </div>
            <span>扫一扫</span>
            <span>关注XLearning公众号</span>
          </el-col>
          <el-col :span="12">
            <div>
              <img src="/static/imgs/footerPage/4.jpg" />
            </div>
            <span>扫一扫</span>
            <span>添加【小碗】微信</span>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <span class="copyright">
     <span> Copyright © 2021 X Learning Co ., LTD. All rights reserved</span>
     <span style="margin-left:10px">备案号：沪ICP备15018954号</span>
    </span>
  </div>
</template>

<script>
export default {
  name: "footerPage",
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.background {
  width: 100%;
  height: 280px;
  background-image: url("/static/imgs/footerPage/1.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  .info {
    width: 100%;
    height: 250px;
    padding-top: 60px;
    padding-left: 150px;

    .left {
      height: 100%;
      display: flex;
      flex-flow: column nowrap;
      text-align: left;
      img {
        width: 220px;
      }
      span {
        color: #fff;
        font-size: 14px;
        margin-top: 10px;
      }
    }

    .right {
      img {
        width: 120px;
      }
      span {
        display: block;
        color: #fff;
        font-size: 14px;
        margin-top: 5px;
      }
    }
  }

  .copyright {
    display: flex;
    color: #a2a2a2;
    font-size: 10px;
    margin-top: 5px;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
    font-family: Dosis,Open Sans,pingfang SC,helvetica neue,arial,hiragino sans gb,microsoft yahei ui,microsoft yahei,simsun,sans-serif;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/footerPage.vue